<template>
  <v-dialog v-model="thisValue" persistent max-width="800px">

    <material-card color="green" title="编辑代理信息">
      <v-form>
        <v-container py-0>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-text-field label="校区ID" type="number" v-model="thisMsg.a_id" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="校区名称" v-model="thisMsg.schoolname" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field class="purple-input" v-model="thisMsg.phone" label="联系电话" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field class="purple-input" v-model="thisMsg._openid" label="Openid" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="账号" v-model="thisMsg.username"  class="purple-input" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="密码"  v-model="thisMsg.password"  class="purple-input" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="总盈利额" disabled v-model="thisMsg.balance"  class="purple-input" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="已提现额" disabled v-model="thisMsg.cash"  class="purple-input" />
            </v-flex>
            <v-flex xs12 md4>
              
          <v-select v-model="thisMsg.can_cash"
            :items="[ { label: '正常', value: true }, { label: '冻结', value: false }]"
            label="是否允许提现" item-text="label" item-value="value" ></v-select>
            </v-flex>
            
            <v-flex xs12 text-xs-right>
              <v-btn color="blue gray" text @click="thisValue = false">关闭</v-btn>
              <v-btn class="mx-0 font-weight-light" style="margin-left: 100px;" @click="doUpdate()" color="success">
                保存
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

    </material-card>
  </v-dialog>
</template>

<script>
let _this;
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    msg: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      thisValue: this.value,
      thisMsg: JSON.parse(JSON.stringify(this.msg)),
      loading: false,
      roles: []
    };
  },
  watch: {
    value(newVal) {
      this.thisValue = newVal;
    },
    thisValue(newVal) {
      this.$emit("change", newVal);
    },
    msg(val) {
      this.thisMsg = val;
    }
  },
  mounted() {
    _this = this;

  },
  methods: {

  async   doUpdate() {
      this.loading = true;
    const res = await  this.$post(
        "admin/updateDlInfo",
        this.thisMsg,  
      )
       {
          _this.loading = false;
          if (res.errno == 0) {
            _this.$message({
              showClose: true,
              message: res.errmsg,
              type: "success"
            });
            _this.thisValue = false;
            _this.$emit("changemsg", res);
          }
        }
    }
  }
};
</script>
